/**
 * External dependencies
 */
import { get } from "lodash";
import moment from "moment";

export default (state) => {
  let operation = get(state, "importOperation.lastImported");

  if (!operation) {
    return null;
  }
  return moment(operation.created_at).format("MMMM Do YYYY, h:mm:ss a");
};
